import { giphyBlack, giphyDarkestGrey, giphyGreen, giphyRed } from '@giphy/js-brand'
import React, { useState } from 'react'
import Tappable from 'react-tappable'
import styled, { keyframes } from 'styled-components'

const tagIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const Remove = styled(Tappable)`
    border-radius: inherit;
    color: #fff;
    display: inline-block;
    font-size: 11px;
    height: 40px;
    line-height: 44px;
    margin-left: -20px;
    padding: 0 5px;
    text-align: center;
    vertical-align: top;

    &:before {
        border-radius: 50%;
        line-height: 23px;
        width: 21px;
        display: inline-block;
        height: 21px;
    }
`

const Label = styled.span`
    display: inline-block;
    padding: 0 20px;
    vertical-align: top;

    &:before {
        content: '#';
    }
`

const Container = styled.li<{ isVertical: boolean }>`
    background: ${giphyDarkestGrey};
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-style: italic;
    font-weight: normal;
    height: 40px;
    line-height: 40px;
    margin-right: 6px;
    position: relative;
    text-transform: lowercase;
    white-space: nowrap;
    animation: ${tagIn} 0.5s ease-out;
    cursor: pointer;

    &:hover {
        color: ${giphyBlack};

        ${Remove}:before {
            color: #fff;
            background-color: #000;
        }
    }
`

type Props = {
    tag: string
    onAdd: (tag: string) => void
    onDelete: (tag: string) => void
    isVertical: boolean
}

const SuggestedTag = ({ tag, onAdd, onDelete, isVertical }: Props) => {
    const [hoverColor, setHoverColor] = useState<string | undefined>(undefined)

    return (
        <Container isVertical={isVertical} style={{ backgroundColor: hoverColor }} onClick={() => onAdd(tag)}>
            <Label onMouseOver={() => setHoverColor(giphyGreen)} onMouseOut={() => setHoverColor(undefined)}>
                {tag}
            </Label>
            <Remove
                className="ss-delete"
                onMouseEnter={() => setHoverColor(giphyRed)}
                onMouseLeave={() => setHoverColor(undefined)}
                onTap={() => onDelete(tag)}
            />
        </Container>
    )
}

export default SuggestedTag
